import { isValid } from "date-fns";
import { ErrorMessage } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

import "./TextareaField.styles.css";

const TextareaField = ({
  Labels,
  Name,
  Classname,
  Placeholder,
  value,
  isInvalid,
  isValid,
  onChange,
  onBlur,
  Rows,
  Cols,
  ID,
  className,
}) => {
  return (
    <Form.Group className={Classname}>
      {Labels && <Form.Label>{Labels}</Form.Label>}
      <Form.Control
        className={className}
        rows={Rows}
        cols={Cols}
        as="textarea"
        id={ID}
        name={Name}
        style={{ border: "1px solid #f0f0f0" }}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isValid={isValid}
        isInvalid={isInvalid}
      />
      <ErrorMessage
        name={Name}
        component="div"
        style={{ color: "red", marginBottom: "5px" }}
      />
    </Form.Group>
  );
};

export default TextareaField;
